import React from 'react';

import clsx from 'clsx';
import { Tooltip as ReactLeafletTooltip } from 'react-leaflet';

import { MapPointer } from '@api/atlas';

import { messageIdConcat } from '@utils/message-id-concat';
import { formatPrice } from '@utils/formatter';

import { Text } from '@atoms';

import {
  MAX_ESTATES_COUNT,
  useFormattedEstatesCount,
} from '@molecules/map-marker/map-marker.hooks';

import classes from './tooltip.module.scss';

type TooltipProps = {
  pointer: MapPointer;
};

const m = messageIdConcat('atlas.tooltip');

export const Tooltip = ({ pointer }: TooltipProps) => {
  const { estatesCount, formattedEstatesCount, hasMultipleEstates } =
    useFormattedEstatesCount(pointer);

  return (
    <ReactLeafletTooltip direction="right" className={classes.leafletTooltip}>
      <span
        className={clsx(
          classes.estatesCountWrapper,
          !hasMultipleEstates && classes.smallCircle,
          estatesCount === MAX_ESTATES_COUNT && classes.largeCircle,
        )}
      >
        {formattedEstatesCount}
      </span>
      {hasMultipleEstates && <span className={classes.averageIcon}>ø</span>}
      <Text
        type="reduced"
        message={{
          id: m('text'),
          values: {
            price: formatPrice(Math.round(pointer.averagePricePerSquareM)),
          },
        }}
        color="white"
        className={classes.text}
      />
    </ReactLeafletTooltip>
  );
};

export default Tooltip;
